module.exports = __webpack_public_path__ + "media/BE-Desktop-Video.df7e7194.mp4";